import React from 'react';
import { Header } from '../Header';
import { Footer } from '../Footer';
export function PrivacyPolicy() {
  return <div className="w-full bg-white" data-id="element-353">
      <Header data-id="element-354" />
      <main className="pt-28 pb-16 bg-white" data-id="element-355">
        <div className="container mx-auto px-4" data-id="element-356">
          <div className="max-w-3xl mx-auto" data-id="element-357">
            <h1 className="text-3xl font-bold text-amber-800 mb-8" data-id="element-358">
              Política de Privacidad
            </h1>
            <div className="prose prose-amber" data-id="element-359">
              <p data-id="element-360">Última actualización: {new Date().toLocaleDateString()}</p>
              <h2 data-id="element-361">1. Información que Recopilamos</h2>
              <p data-id="element-362">
                Recopilamos información personal como su nombre, dirección de
                correo electrónico y detalles de pago cuando realiza una compra
                en nuestro sitio web. También podemos recopilar información
                sobre cómo interactúa con nuestro sitio web.
              </p>
              <h2 data-id="element-363">2. Uso de la Información</h2>
              <p data-id="element-364">
                Utilizamos la información recopilada para procesar sus pedidos,
                mejorar nuestros servicios, enviar comunicaciones de marketing
                (si ha dado su consentimiento) y cumplir con nuestras
                obligaciones legales.
              </p>
              <h2 data-id="element-365">3. Protección de Datos</h2>
              <p data-id="element-366">
                Implementamos medidas de seguridad apropiadas para proteger su
                información personal contra acceso, alteración o divulgación no
                autorizados.
              </p>
              <h2 data-id="element-367">4. Cookies</h2>
              <p data-id="element-368">
                Utilizamos cookies para mejorar su experiencia en nuestro sitio
                web. Puede configurar su navegador para rechazar todas las
                cookies o para indicar cuándo se está enviando una cookie.
              </p>
              <h2 data-id="element-369">5. Compartir Información</h2>
              <p data-id="element-370">
                No vendemos, intercambiamos ni transferimos su información
                personal a terceros sin su consentimiento, excepto cuando sea
                necesario para cumplir con la ley o proteger nuestros derechos.
              </p>
              <h2 data-id="element-371">6. Sus Derechos</h2>
              <p data-id="element-372">
                Tiene derecho a acceder, corregir o eliminar su información
                personal. También puede oponerse al procesamiento de sus datos o
                solicitar la portabilidad de los mismos.
              </p>
              <h2 data-id="element-373">7. Cambios en la Política de Privacidad</h2>
              <p data-id="element-374">
                Nos reservamos el derecho de modificar esta política en
                cualquier momento. Los cambios entrarán en vigor inmediatamente
                después de su publicación en el sitio web.
              </p>
              <h2 data-id="element-375">8. Contacto</h2>
              <p data-id="element-376">
                Si tiene alguna pregunta sobre nuestra Política de Privacidad,
                puede contactarnos a través de nuestro formulario de contacto o
                por correo electrónico.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-377" />
    </div>;
}